import logo from '../images/app_logo.png'

function Splash() {
  return (
    <div className='bg-white flex flex-col items-center justify-center h-screen w-screen'>
      <img className='w-[300px] md:w-[30%] md:h-[30%] object-contain flex items-center -mt-0.5 ' src={logo} />
    </div>
  )
}

export default Splash